import { type PropsWithChildren } from "react";
import { Drawer as VaulDrawer } from "vaul";
import { ClientOnly } from "@tanstack/react-router";

export interface DrawerProps extends PropsWithChildren {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const Drawer = ({ open, onOpenChange, children }: DrawerProps) => {
  return (
    <ClientOnly>
      <VaulDrawer.Root
        direction="right"
        open={open}
        onOpenChange={onOpenChange}
      >
        <VaulDrawer.Overlay className="fixed z-30 inset-0 bg-black/50 " />
        <VaulDrawer.Content className="right-0 z-40 top-0 bottom-0 fixed outline-none w-full max-w-[768px] bg-default-background z-10 overflow-auto">
          <div className="w-full">{children}</div>
        </VaulDrawer.Content>
      </VaulDrawer.Root>
    </ClientOnly>
  );
};
